<template>
	<div>
		<div v-if="!innerIsReview">
			<validation-provider
					v-slot="{ errors }"
					:name="label || 'This'"
					:rules="rules"
					v-bind="providerProps"
					v-show="innerShouldShow"
					:vid="'validate-' + fieldAssignmentId"
			>
                <span
										class="field-directions"
										v-if="directions"
										v-html="directions"
								></span>
				<v-row v-for="day in days" :key="'row' + day.day" dense>
					<v-col cols="12" md="2">
						{{ day.label }}
					</v-col>
					<v-col cols="12" md="1">
						<v-switch
								v-model="day.selected"
								@click="formatDayText()"
						></v-switch>
					</v-col>
					<v-col cols="12" md="3">
						<!--                        :return-value.sync="day.openTime"-->
						<v-menu
								v-if="day.selected"
								:ref="'menu1' + day.day"
								v-model="day.menu1"
								:close-on-content-click="false"
								:nudge-right="40"
								transition="scale-transition"
								offset-y
								max-width="290px"
								min-width="290px"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
										v-model="day.open"
										label="Open"
										readonly
										v-bind="attrs"
										v-on="on"
										outlined
								></v-text-field>
							</template>
							<v-time-picker
									v-if="day.menu1"
									v-model="day.openTime"
									full-width
									ampm-in-title
									@click:hour="closeMenu"
									@click:minute="closeMenu"
									@update:period="
                                    updatePeriod($event, day.day, 'open')
                                "
							></v-time-picker>
						</v-menu>
						<span v-else class="text--disabled">Closed</span>
					</v-col>
					<v-col cols="12" md="3">
						<!--                        :return-value.sync="day.closeTime"-->
						<v-menu
								v-if="day.selected"
								:ref="'menu2' + day.day"
								v-model="day.menu2"
								:close-on-content-click="false"
								:nudge-right="40"
								transition="scale-transition"
								offset-y
								max-width="290px"
								min-width="290px"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-text-field
										v-model="day.close"
										label="Closed"
										readonly
										v-bind="attrs"
										v-on="on"
										outlined
								></v-text-field>
							</template>
							<v-time-picker
									v-if="day.menu2"
									v-model="day.closeTime"
									full-width
									ampm-in-title
									@click:hour="closeMenu"
									@click:minute="closeMenu"
									@update:period="
                                    updatePeriod($event, day.day, 'close')
                                "
							></v-time-picker>
						</v-menu>
					</v-col>
				</v-row>
			</validation-provider>
		</div>
		<div v-else>
			<type-review
					v-if="extraProps"
					:label="label"
					:directions="directions"
					:should-show="innerShouldShow"
					:show-edit-button="extraProps.editButton"
					:page-number="extraProps.originalPageNumber"
					@goToPage="goToPage($event)"
			>
				<v-row v-for="(day, i) in weekText" :key="'weekday-' + i">
					{{ day }}
				</v-row>
			</type-review>
		</div>
	</div>
</template>

<script>
import formMixin from '../formMixin';
import TypeReview from './TypeReview';

export default {
	name: 'TypeBusinessHours',
	mixins: [formMixin],
	components: {
		TypeReview
	},
	data() {
		return {
			days: [
				{
					label: 'Sunday',
					selected: 0,
					open: '',
					openTime: '',
					close: '',
					closeTime: '',
					day: 0,
					menu1: false,
					menu2: false
				},
				{
					label: 'Monday',
					selected: 0,
					open: '',
					openTime: '',
					close: '',
					closeTime: '',
					day: 1,
					menu1: false,
					menu2: false
				},
				{
					label: 'Tuesday',
					selected: 0,
					open: '',
					openTime: '',
					close: '',
					closeTime: '',
					day: 2,
					menu1: false,
					menu2: false
				},
				{
					label: 'Wednesday',
					selected: 0,
					open: '',
					openTime: '',
					close: '',
					closeTime: '',
					day: 3,
					menu1: false,
					menu2: false
				},
				{
					label: 'Thursday',
					selected: 0,
					open: '',
					openTime: '',
					close: '',
					closeTime: '',
					day: 4,
					menu1: false,
					menu2: false
				},
				{
					label: 'Friday',
					selected: 0,
					open: '',
					openTime: '',
					close: '',
					closeTime: '',
					day: 5,
					menu1: false,
					menu2: false
				},
				{
					label: 'Saturday',
					selected: 0,
					open: '',
					openTime: '',
					close: '',
					closeTime: '',
					day: 6,
					menu1: false,
					menu2: false
				}
			]
		};
	},
	mounted() {
		this.updateBusinessHours();
		this.fieldLoaded(); // signal to the form we are loaded
	},
	computed: {
		defaults() {
			return {
				label: this.innerLabel,
				persistentHint: true
			};
		},
		rules() {
			return (this.enableValidation) ? {
				...this.validation_settings,
				...{
					required:
							!!this.validation_settings.required &&
							!!this.innerShouldShow
				}
			} : {};
		},
		weekText() {
			return this.innerValue.weekday_text || [];
		}
	},
	watch: {
		innerValue(val) {
			this.updateBusinessHours();
		}
	},
	methods: {
		closeMenu() {
			// this.$refs[menu][0].save(time)
			this.formatDayText();
		},
		updatePeriod(period, day, openClosed) {
			// the am pm period seems to not update the first time it is clicked. Subsequent toggles end up out of sync.
			// perhaps not ideal, this assures that the first and all following toggles are caught.
			const timeArr = this.days[day][openClosed].split(' ');
			timeArr[1] = period.toUpperCase();
			this.days[day][openClosed] = timeArr.join(' ');

			// this step will then pass the ampm value off to be added to innerValue and saved
			this.formatDayText(true, this.days);
		},
		daySelected(day) {
			day.selected = !day.selected;
			// this.formatDayText();
		},
		formatDayText(period = false, periodData = null) {
			const val = { periods: [], weekday_text: [] };
			for (let day of this.days) {
				if(day.selected) {
					val.periods.push({
						open: {
							day: day.day,
							time: !period
									? moment('01/01/2020 ' + day.openTime).format(
											'HHmm'
									)
									: moment(
											periodData[day.day].open,
											'h:mm A'
									).format('HHmm')
						},
						close: {
							day: day.day,
							time: !period
									? moment('01/01/2020 ' + day.closeTime).format(
											'HHmm'
									)
									: moment(
											periodData[day.day].close,
											'h:mm A'
									).format('HHmm')
						}
					});

					val.weekday_text.push(
							day.label + ': ' + day.open + ' - ' + day.close
					);
				}
				else {
					val.weekday_text.push(day.label + ': Closed');
				}
			}

			this.innerValue = { ...val };
		},
		updateBusinessHours() {
			if(
					this.innerValue &&
					this.innerValue.periods &&
					this.innerValue.periods.length
			) {
				this.days.forEach(x => (x.selected = false));

				this.innerValue.periods.forEach(p => {
					if(p.open && p.open.time) {
						let day = this.days.find(x => x.day == p.open.day);
						if(day) {
							const ot = moment(
									'01/01/2020 ' + p.open.time,
									'MM/DD/YYYY HHmm'
							);
							day.open = ot.format('h:mm A');
							if(!day.openTime)
								day.openTime = ot.format('HH:mm');
							day.selected = 1;
						}
					}
					if(p.close && p.close.time) {
						let day = this.days.find(x => x.day == p.close.day);
						if(day) {
							const ct = moment(
									'01/01/2020 ' + p.close.time,
									'MM/DD/YYYY HHmm'
							);
							day.close = ct.format('h:mm A');
							if(!day.closeTime)
								day.closeTime = ct.format('HH:mm');
							day.selected = 1;
						}
					}
				});
			}
		}
	}
};

// {"label":"Monday","selected":1,"open":"8:25 AM","openTime":"08:25","close":"8:25 PM","closeTime":"20:25","day":1,"menu1":false,"menu2":false}
// {"label":"Monday","selected":true,"open":"8:25 AM","openTime":"0825","close":"8:25 PM","closeTime":"2025","day":1,"menu1":false,"menu2":false}
</script>

<style lang="scss">
.v-time-picker-clock__hand,
.v-time-picker-clock__item--active {
	background-color: #003e52 !important;
}
</style>
